import React from 'react';
import { useSearch } from '@spa/features/search_job/pc/contexts/SearchContext';
import SuggestInput from "@spa/features/search_job/pc/components/suggest/SuggestInput";
import {useTrack} from "@spa/features/search_job/pc/contexts/TrackContext";
import {trackSearchBoxSearchClick} from "@spa/features/search_job/pc/api/analytics/trackEvent";
import {usePage} from "@inertiajs/react";

const SearchForm = () => {
    const {
        keyword,
        location,
        keywordPlaceholder,
        locationPlaceholder,
        handleSearch,
        handleKeywordChange,
        handleLocationChange,
        setKeyword,
        setLocation,
    } = useSearch();
    const {channelName} = useTrack();
    const { translations } = usePage().props;

    return (
        <div className="p-head_main_form">
            <form id="s-search_form" onSubmit={handleSearch}>
                <div className="p-headSearch_wrap">
                    <div className="p-headSearch_upper">
                        <div className="p-form_wrap">
                            {/* keyword */}
                            <SuggestInput
                                id="s-keywordSearch1_fire"
                                name="keyword"
                                inputValue={keyword}
                                maxLength="136"
                                type="keyword"
                                updateInputValue={handleKeywordChange}
                                updateSelectedValue={setKeyword}
                                apiPath={suggestKeywordApiPath}
                                placeholder={keywordPlaceholder}
                                inputClassName="s-form--keyword"
                            />
                        </div>
                        <hr className="p-head_main_hr" />
                        <div className="p-form_wrap">
                            {/* location */}
                            <SuggestInput
                                id="s-locationSearch1_fire"
                                name="location"
                                inputValue={location}
                                maxLength="150"
                                type="location"
                                updateInputValue={handleLocationChange}
                                updateSelectedValue={setLocation}
                                apiPath={suggestApiPath}
                                placeholder={locationPlaceholder}
                                inputClassName="s-form--location"
                            />
                        </div>
                    </div>
                    <button type="submit" className="c-search_btn p-headSearch_submit s-search_btn"　onClick={() => trackSearchBoxSearchClick(channelName)}>
                        {translations.search_jobs}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SearchForm;
